export const translations = {
	'Servicelog details': {
		no: 'Tjenestelogg detaljer',
	},
	'Please select an account...': {
		no: 'Velg konto...',
	},
	'No items available.': {
		no: 'Ingen elementer er tilgjengelig',
	},
	'Raw data': {
		no: 'Raw data',
	},
	'Click here to select new metric': {
		no: 'Klikk her for å velge metrikker',
	},
	'Selected metrics': {
		no: 'Valgte metrikker',
	},
	'Servicequalifier': {
		no: 'Tjenestepunkt',
	},
	'Select service element': {
		no: 'Velg tjenesteelement',
	},
	'Select metric': {
		no: 'Velg metrikk',
	},
	'Add metric': {
		no: 'Legg til metrikk',
	},
	'Select assetgroup': {
		no: 'Velg ressursgrupper',
	},
	'Select metric categories': {
		no: 'Velg metrikk roller',
	},
	'Select custom period date': {
		no: 'Velg dato periode',
	},
	'Account status': {
		no: 'Konto status',
	},
	'Service state': {
		no: 'Tilstand',
	},
	'Service health': {
		no: 'Tjenestehelse',
	},
	'SLA Status': {
		no: 'SLA status',
	},
	'In compliance': {
		no: 'Samsvar',
	},
	' No SLA Available': {
		no: 'Ingen SLA',
	},
	'Health': {
		no: 'Helse',
	},
	'No services found.': {
		no: 'Ingen tjenester tilgjengelig',
	},
	'Coverage': {
		no: 'Dekning',
	},
	'Current state': {
		no: 'Nåværende tilstand',
	},
	'State change': {
		no: 'Tilstands endring',
	},
	'Sequence number': {
		no: 'Sekvens nummer',
	},
	'Sample time': {
		no: 'Samplings tid',
	},
	'Object name': {
		no: 'Objekt navn',
	},
	'Event id': {
		no: 'Hendelse id',
	},
	'Hide header': {
		no: 'Skjul tittel',
	},
	'Transparent': {
		no: 'Gjennomsiktig',
	},
	'Fit image': {
		no: 'Tilpass bilde',
	},
	'Click to select image': {
		no: 'Klikk for å velge et bilde',
	},
	'Reasons for': {
		no: 'Årsåker for',
	},
	'Servicequalifiers': {
		no: 'Tjenestepunkter',
	},
	'No qualifiers': {
		no: 'Ingen punkter',
	},
	'Add servicequalifier': {
		no: 'Legg til tjenestepunkt',
	},
	'Hide border': {
		no: 'Skjul ramme',
	},
	'Gradient fill': {
		no: 'Gradientfyll',
	},
	'Gradient direction': {
		no: 'Gradientretning',
	},
	'Gradient start color': {
		no: 'Gradient startfarge',
	},
	'Gradient finish color': {
		no: 'Gradient sluttfarge',
	},
};
